"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2211],{

/***/ 7171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M0": function() { return /* binding */ LandingWhiteSec; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "kj": function() { return /* binding */ LandingGreySecWrap; },
/* harmony export */   "zq": function() { return /* binding */ LandingGreySec; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var Flex = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__Flex",
  componentId: "sc-1i94ptm-0"
})(["display:flex;align-items:center;"]);
var LandingGreySec = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingGreySec",
  componentId: "sc-1i94ptm-1"
})(["background:#f5f5f5;padding:", ";margin-top:-120px;margin-bottom:", ";@media only screen and (max-width:768px){padding:", ";margin-top:", ";}"], function (props) {
  return props.padding;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.padding || "16px";
}, function (props) {
  return props.marginTop || "0px";
});
var LandingGreySecWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingGreySecWrap",
  componentId: "sc-1i94ptm-2"
})(["width:1200px;margin:0 auto;background:#f5f5f5;@media only screen and (max-width:768px){width:100%;}"]);
var LandingWhiteSec = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingWhiteSec",
  componentId: "sc-1i94ptm-3"
})(["width:1200px;margin:0 auto;background:#fff;padding:", ";@media only screen and (max-width:768px){width:100%;padding:16px;}"], function (props) {
  return props.padding;
});

/***/ }),

/***/ 2211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ privacySection; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/usePrivacyAnimation/index.tsx
var usePrivacyAnimation = __webpack_require__(8724);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/Image/index.tsx + 1 modules
var Image = __webpack_require__(8863);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingPrivacy/LandingPrivacy.style.ts

var LandingPrivacyStyled = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingPrivacystyle__LandingPrivacyStyled",
  componentId: "sc-1xkyn0y-0"
})(["background:#ffffff;display:flex;justify-content:space-between;margin-bottom:164px;align-items:center;"]);
var LandingPrivacyTitle = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "LandingPrivacystyle__LandingPrivacyTitle",
  componentId: "sc-1xkyn0y-1"
})(["font-family:\"Raleway\";font-weight:400;font-size:56px;line-height:72px;margin-bottom:24px;color:#000000;"]);
var LandingPrivacyImg = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingPrivacystyle__LandingPrivacyImg",
  componentId: "sc-1xkyn0y-2"
})(["margin-left:40px;background:linear-gradient(152.97deg,#ffffff 13.39%,#c7c7c7 87.18%);border-radius:100%;display:flex;align-items:center;justify-content:center;width:232px;height:232px;flex-shrink:0;position:relative;z-index:1;padding-top:46px;&:after{content:\"\";position:absolute;top:0;left:0;background:linear-gradient( 152.97deg,rgba(236,213,213,0.6) 13.39%,rgba(220,220,220,0) 87.18% );border-radius:100%;width:232px;height:232px;z-index:-1;}& .lockFront2{position:absolute;top:100px;left:79px;}& .lockVer{position:absolute;opacity:0;top:110px;left:85px;}& .lockUpper{position:absolute;z-index:-1;top:5px;left:85px;}"]);
var LandingPrivacyTitleList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingPrivacystyle__LandingPrivacyTitleList",
  componentId: "sc-1xkyn0y-3"
})(["font-weight:400;font-size:18px;line-height:32px;padding-left:18px;gap:72px;display:flex;& li{position:relative;}& li:after{content:\"\";position:absolute;width:5px;height:14px;left:-18px;top:8px;background:#ff4d00;border-radius:14px;}"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingPrivacy/LandingPrivacy.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var LandingPrivacy = function LandingPrivacy(_ref) {
  var _imgs$, _imgs$2, _imgs$3, _imgs$4;

  var title = _ref.title,
      list = _ref.list,
      imgs = _ref.imgs;
  (0,usePrivacyAnimation/* usePrivacyAnimation */.B)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingPrivacyStyled, {
    id: "lock_privacy_ref",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingPrivacyTitle, {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingPrivacyTitleList, {
        children: list === null || list === void 0 ? void 0 : list.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: item
          }, index);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingPrivacyImg, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread(_objectSpread({
        id: "lockFront_ref",
        className: "lockFront"
      }, imgs === null || imgs === void 0 ? void 0 : imgs[0]), {}, {
        loading: (imgs === null || imgs === void 0 ? void 0 : (_imgs$ = imgs[0]) === null || _imgs$ === void 0 ? void 0 : _imgs$.loading) || "lazy"
      })), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread(_objectSpread({
        id: "lockFront2_ref",
        className: "lockFront2"
      }, imgs === null || imgs === void 0 ? void 0 : imgs[1]), {}, {
        loading: (imgs === null || imgs === void 0 ? void 0 : (_imgs$2 = imgs[1]) === null || _imgs$2 === void 0 ? void 0 : _imgs$2.loading) || "lazy"
      })), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread(_objectSpread({
        id: "lockVer_ref",
        className: "lockVer"
      }, imgs === null || imgs === void 0 ? void 0 : imgs[2]), {}, {
        loading: (imgs === null || imgs === void 0 ? void 0 : (_imgs$3 = imgs[2]) === null || _imgs$3 === void 0 ? void 0 : _imgs$3.loading) || "lazy"
      })), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread(_objectSpread({
        id: "lock_ref",
        className: "lockUpper"
      }, imgs === null || imgs === void 0 ? void 0 : imgs[3]), {}, {
        loading: (imgs === null || imgs === void 0 ? void 0 : (_imgs$4 = imgs[3]) === null || _imgs$4 === void 0 ? void 0 : _imgs$4.loading) || "lazy"
      }))]
    })]
  });
};

/* harmony default export */ var LandingPrivacy_LandingPrivacy = (LandingPrivacy);
// EXTERNAL MODULE: ../../libs/ui/src/lib/shared-styled-components/index.ts
var shared_styled_components = __webpack_require__(7171);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/privacySection/index.tsx


function privacySection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function privacySection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? privacySection_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : privacySection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var PrivacySection = function PrivacySection(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(shared_styled_components/* LandingWhiteSec */.M0, {
    padding: "84px 0 0 0",
    id: "privacy_ref",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingPrivacy_LandingPrivacy, privacySection_objectSpread({}, props))
  });
};

/* harmony default export */ var privacySection = (PrivacySection);

/***/ })

}]);